mutation downgradeToLight($input: DowngradeToLightInput!) {
  downgradeToLight(input: $input)
}
